import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// GA4 wrapper — never send PII in params
export const track = (event, params = {}) => {
  if (typeof window.gtag === "function") window.gtag("event", event, params);
};

export function AnalyticsTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.origin + pathname,
        page_title: document.title,
      });
    }
  }, [pathname]);
  return null;
}
